import { Component, inject, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_LOADER } from '@progress/kendo-angular-indicators';
import { KENDO_CARD, KENDO_LAYOUT } from '@progress/kendo-angular-layout';
import { TrackFormDirective } from '@unity/directives/track-form.directive';
import { IconService } from '@unity/services/icon.service';
import { LayoutService } from '@unity/services/layout.service';

@Component({
  selector: 'unity-card-new-shared',
  imports: [ReactiveFormsModule, TrackFormDirective, KENDO_LAYOUT, KENDO_CARD, KENDO_BUTTON, KENDO_LOADER],
  templateUrl: './card-new-shared.component.html',
  styleUrl: './card-new-shared.component.scss',
})
export class CardNewSharedComponent {
  private readonly layoutService = inject(LayoutService);
  private readonly iconService = inject(IconService);

  public readonly $formGroup = input.required<FormGroup>({ alias: 'formGroup' });
  public readonly $actionName = input<string>('Create', { alias: 'actionName' });
  public readonly $formLoading = input.required<boolean>({ alias: 'formLoading' });
  public readonly $showSubmit = input<boolean>(true, { alias: 'showSubmit' });

  protected submitIcon = this.iconService.uploadIcon;

  protected readonly rowGap = this.layoutService.newRecordFormGridLayoutGap.rows;

  public submitEvent = output();

  protected onSubmit() {
    this.submitEvent.emit();
  }
}
